import { Box, Button, TextField } from '@mui/material'
import React, { useRef } from 'react'

interface ItemCodeInputProps {
  itemCode: string
  onItemCodeChange: (value: string) => void
  onSubmit: () => void
  onBack: () => void
  loading: boolean
}

const ItemCodeInput: React.FC<ItemCodeInputProps> = ({
  itemCode,
  onItemCodeChange,
  onSubmit,
  onBack,
  loading
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      onSubmit()
    }
  }

  return (
    <>
      <Box sx={{ margin: '20px' }}>
        <Button variant='outlined' onClick={onBack} disabled={loading}>
          Back
        </Button>
      </Box>
      <Box
        sx={{
          width: '80%',
          margin: '100px auto',
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}
      >
        <TextField
          inputRef={inputRef}
          autoFocus
          fullWidth
          label='Item Code'
          value={itemCode}
          onChange={e => onItemCodeChange(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <Button
          variant='contained'
          onClick={onSubmit}
          disabled={loading}
          sx={{
            background: 'linear-gradient(45deg, #364c63, #5f799a)',
            color: 'white',
            fontWeight: 600,
            padding: '12px 0',
            fontSize: '18px',
            textTransform: 'none',
            borderRadius: '8px',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              background: 'linear-gradient(45deg, #4b6485, #758aa8)',
              transform: 'translateY(-2px)'
            }
          }}
        >
          {loading ? 'Loading...' : 'Submit'}
        </Button>
      </Box>
    </>
  )
}

export default ItemCodeInput
